import { model as router } from '!/router'
import { api } from '@setplex/tria-api'
import { sample } from 'effector'

// on successful purchase - just reinit current route
// this will cause all data, needed for current page, refetched
// instead of `location.reload()` this will not look like actual page reload
sample({
  clock: api.purchases.initializePurchaseProcessFx.done,
  target: router.refresh,
})
